module.exports = __webpack_public_path__ + "static/media/course-outstanding.c53ffd1b.svg";